import * as React from 'react';
import { observer } from 'mobx-react';

import { ErrorBoundary } from 'bernie-view';
import { Viewport, ViewLarge, ViewMedium, ViewSmall } from '@shared-ui/viewport-context';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';

import { UitkSpacing, UitkSpacingProps } from 'uitk-react-spacing';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkHeading, UitkText } from 'uitk-react-text';

import { UniversalFilterPills } from './smart-universal-filter-pills';
import { useStores } from 'utility/hooks';
import { ErrorBoundaryLabel } from 'utility';
import { UitkLayoutGrid } from 'uitk-react-layout-grid';

const FilterPillsSpacingProps: UitkSpacingProps = {
  margin: { blockend: 'four' }
};

const SmartShoppingsPillsSpacingProps: UitkSpacingProps = {
  margin: { blockend: 'six' }
};

const FilterPillsMobSpacingProps: UitkSpacingProps = {
  margin: { blockend: 'six' }
};

const ListingsHeadingAndPillsSpacingProps: UitkSpacingProps = {
  margin: { inline: 'three' }
};

const ListingsHeading = observer(function ListingsHeading() {
  const { flightsSearchMetadataStore, listingsStore } = useStores();

  return (
    <>
      {flightsSearchMetadataStore && !listingsStore.smartShoppingError && (
        <UitkLayoutFlexItem minWidth="zero" grow={1}>
          <UitkSpacing margin={FilterPillsSpacingProps.margin}>
            <div>
              <UitkHeading tag="h2" size={5}>
                <Experiment name="EGTNL_Air_Smart_Shopping">
                  <ExperimentVariant bucket={1}>
                    <strong>{flightsSearchMetadataStore.primary}</strong>
                  </ExperimentVariant>
                  <ExperimentControl>{flightsSearchMetadataStore.primary}</ExperimentControl>
                </Experiment>
              </UitkHeading>
              <UitkText size={100} spacing="two">
                {flightsSearchMetadataStore.secondary}
              </UitkText>
            </div>
          </UitkSpacing>
        </UitkLayoutFlexItem>
      )}
    </>
  );
});

export const ListingsHeaderBar = observer(function ListingsHeaderBar() {
  const { listingsStore, searchCriteriaStore } = useStores();
  const { hasWebFlightCardCriteria } = searchCriteriaStore;
  const shouldShowHeader =
    !hasWebFlightCardCriteria && !listingsStore.smartShoppingFirstLoading && !listingsStore.smartShoppingError;

  const listingsHeadingAndFiltersSmall = (
    <UitkLayoutGrid alignItems="start" columns={1}>
      <ListingsHeading />
      <UitkSpacing margin={FilterPillsMobSpacingProps.margin}>
        <div>
          <UniversalFilterPills />
        </div>
      </UitkSpacing>
    </UitkLayoutGrid>
  );

  const listingsHeadingAndFiltersMediumLarge = (
    <UitkLayoutFlex alignItems="center" space="six" wrap="wrap">
      <ListingsHeading />
      <UitkLayoutFlexItem>
        <UitkSpacing margin={SmartShoppingsPillsSpacingProps.margin}>
          <div>
            <UniversalFilterPills />
          </div>
        </UitkSpacing>
      </UitkLayoutFlexItem>
    </UitkLayoutFlex>
  );

  return (
    <>
      {shouldShowHeader && (
        <ErrorBoundary label={ErrorBoundaryLabel.SMART_SHOPPING_HEADER}>
          <Viewport>
            <ViewSmall>
              <UitkSpacing margin={ListingsHeadingAndPillsSpacingProps.margin}>
                {listingsHeadingAndFiltersSmall}
              </UitkSpacing>
            </ViewSmall>
            <ViewMedium>
              <UitkSpacing margin={ListingsHeadingAndPillsSpacingProps.margin}>
                {listingsHeadingAndFiltersMediumLarge}
              </UitkSpacing>
            </ViewMedium>
            <ViewLarge>{listingsHeadingAndFiltersMediumLarge}</ViewLarge>
          </Viewport>
        </ErrorBoundary>
      )}
    </>
  );
}) as React.FunctionComponent;
